module.exports = __webpack_public_path__ + "static/media/1013017.22957745.jpg";